import React, { useState, useEffect } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import moment from 'moment';

import { GET, newFetch } from '../../../helpers/fetch';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';

const TroubleTicketing = ({ history }) => {
  const type = localStorage.getItem('type');
  const user = JSON.parse(localStorage.getItem('user'));
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const siteID = parseInt(localStorage.getItem('site'), 10);
  const [clients, setClients] = useState([]);
  const [activeClient, setActiveClient] = useState(null);
  const [sites, setSites] = useState([]);
  const [activeSite, setActiveSite] = useState(null);
  const [tickets, setTickets] = useState([]);

  const fetchClients = async () => {
    try {
      let api_path = '/client';
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let clientsData = response.data;
        clientsData = clientsData.filter(
          (client) => client.enable_trouble_ticketing
        );
        setClients(clientsData);
        clientsData.length > 0 && setActiveClient(clientsData[0]);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSites = async () => {
    try {
      let api_path = type !== 'client' ? '/sites' : `/client/${user.id}/site`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setSites(response.data);
        response.data.length > 0 && setActiveSite(response.data[0]);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClientById = async () => {
    try {
      let api_path = `/client/${clientID}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setClients(response.data);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClientSites = async (id) => {
    try {
      let api_path = `/client/${id}/site`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let filtered = response.data.filter((site) => site.active);
        setSites(filtered);
        setActiveSite(filtered[0]);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSupervisorSites = async (client_id, idArr) => {
    let sites = await Promise.all(
      idArr.map(async (id) => {
        try {
          let api_path = `/client/${client_id}/site/${id}`;
          let response = await newFetch(GET, api_path);

          if (response.success) {
            return response.data;
          } else {
            ToastUtil.error(response.message);
          }
        } catch (error) {
          console.log(error);
        }
      })
    );

    let filtered = sites.filter((site) => site.active);
    setSites(filtered);
    setActiveSite(filtered[0]);
  };

  const fetchTicketsAdmin = async (clientID, siteID) => {
    try {
      let api_path = `/client/${clientID}/site/${siteID}/ticket`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setTickets(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSupervisorTickets = async () => {
    try {
      let api_path = `/tt/supervisor/tickets`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setTickets(response.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (type === 'client') {
      fetchClientSites(user.id);
    } else {
      // fetchClients();
    }
  }, []);

  useEffect(() => {
    if (activeClient) fetchClientSites(activeClient.id);
  }, [activeClient]);

  useEffect(() => {
    fetchTicketsAdmin(clientID, siteID);
  }, [siteID]);

  useEffect(() => {}, [tickets]);

  useEffect(() => {
    fetchClientById();
  }, [clientID]);

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '6rem',
      }}
    >
      <div className="border-bottom pb-2 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
          Trouble Ticketing (TT)
        </h6>
        {clients.enable_trouble_ticketing && (
          <NavLink
            to={`/trouble-ticketing/add`}
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <button
              className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
              style={{ width: '200px' }}
            >
              Add New
            </button>
          </NavLink>
        )}
      </div>

      {clients.enable_trouble_ticketing ? (
        <>
          <div className="d-flex align-items-center pb-2">
            <h6 className="flex-fill pt-4">Tickets ({tickets.length})</h6>
          </div>

          <div className="table-responsive rounded shadow bg-white">
            <table className="table table-borderless mb-0">
              <thead className="border-bottom">
                <tr>
                  <th className="py-3 text-muted fw-normal">Ticket ID</th>
                  <th className="py-3 text-muted fw-normal">Incident</th>
                  <th className="py-3 text-muted fw-normal text-center">
                    SEV Level
                  </th>
                  <th className="py-3 text-muted fw-normal">Site</th>
                  <th className="py-3 text-muted fw-normal">TT Group</th>
                  <th className="py-3 text-muted fw-normal">Date Created</th>
                  <th className="py-3 text-muted fw-normal">Status</th>
                </tr>
              </thead>
              <tbody>
                {tickets && tickets.length > 0 ? (
                  tickets
                    .sort(
                      (a, b) =>
                        moment(b.createdAt, 'YYYY-MM-DD HH:mm:ss') -
                        moment(a.createdAt, 'YYYY-MM-DD HH:mm:ss')
                    )
                    .map((ticket) => {
                      return (
                        <tr
                          key={ticket.id}
                          className="border-bottom"
                          style={{ cursor: 'pointer' }}
                          onClick={() =>
                            history.push(
                              `/trouble-ticketing/detail/${ticket.id}`
                            )
                          }
                        >
                          <td className="text-muted">{ticket.ticket_id}</td>
                          <td className="text-muted">{ticket.incident.name}</td>
                          <td className="text-center">
                            <span className="badge rounded-pill text-bg-secondary p-2">
                              {ticket.incident.severity.id}
                            </span>
                          </td>
                          <td>
                            <span className="pb-2 badge rounded-pill text-bg-primary p-2">
                              {ticket.site.name}
                            </span>
                          </td>
                          <td className="text-muted">
                            {ticket.groups
                              .map((group) => group.name)
                              .join(', ')}
                          </td>
                          <td className="text-muted">
                            {moment(
                              ticket.createdAt,
                              'YYYY-MM-DD HH:mm:ss'
                            ).format('DD MMM YYYY, HH:mma')}
                          </td>
                          <td>
                            <span
                              className={
                                'p-2 badge rounded-pill ' +
                                (ticket.status.id === 1
                                  ? 'text-bg-warning'
                                  : ticket.status.id === 2
                                  ? 'text-bg-success'
                                  : ticket.status.id === 3
                                  ? 'text-bg-secondary'
                                  : '')
                              }
                            >
                              {ticket.status.name}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No tickets found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="text-muted pt-4">
          The client does not have access to this module.
        </div>
      )}
    </div>
  );
};

export default withRouter(TroubleTicketing);
